import { createReducer, on, Action } from '@ngrx/store';
import { cctcolorActionTypes } from './cct-color.actions';
import {
    cctColorAdapter,
    CCTColorState
} from './cct-color.entity';

import * as _ from 'lodash';
import { authActionTypes } from './../../../auth/store/auth.actions';

export const initialState: CCTColorState = cctColorAdapter.getInitialState({
    ids: [],
    entities: null,
    total: 0,
    loaded: false
});

export const cctColorReducerObj = createReducer(
    initialState,
    on(cctcolorActionTypes.setCCTColors, (state, action) => {
        return cctColorAdapter.addAll(action.cctColors, { ...state, loaded: action.cctColors.length > 0, total: action.cctColors.length })
    }),

    on(cctcolorActionTypes.add, (state, action) => {
        return cctColorAdapter.addOne(action.color, { ...state, total: state.total + 1 })
    }),

    on(cctcolorActionTypes.deleteCCT, (state, action) => {
        return cctColorAdapter.removeOne(action.id, { ...state, total: state.total - 1 })
    }),

    on(authActionTypes.LogOut, (state, action) => {
        return cctColorAdapter.removeAll(state)
        // return {
        //   ...state
        // }
    }),

    on(cctcolorActionTypes.clear, (state, action) => {
        return cctColorAdapter.removeAll(state)
    })

);

export function cctColorReducer(state: CCTColorState = initialState, action: Action): CCTColorState {
    return cctColorReducerObj(state, action);
}

export const cctColorSelectors = cctColorAdapter.getSelectors();
